import type { BreedListPageFormValues } from '@presentation/pages';

export const PAGINATED_SIZE = 32;

export const FORM_INITIAL_VALUES: BreedListPageFormValues = {
  allergic: undefined,
  independant: undefined,
  size: [],
  dogType: [],
  maintenanceType: [],
  fciGroupType: [],
  hairType: [],
};
